import { getUrlParams } from '@lux/helpers';
import CONSTANTS from '../constants/common';

interface UiamUrlParams {
  accessToken: string;
  targetUrl: string;
}

function extractBTLTargetUrl(pathName: string): string | null {
  const params = new URLSearchParams(pathName);
  const targetUrl = params.get('targetUrl');
  if (!targetUrl) return null;
  try {
    // Validate URL
    const url = new URL(targetUrl);
    return url.toString();
  } catch {
    return null;
  }
}

export const getUiamUrlParams = (pathName: string): UiamUrlParams => {
  if (!pathName) return null;
  let accessToken, targetUrl;
  const responseQueryParams = getUrlParams(pathName);
  if (responseQueryParams?.accessToken && responseQueryParams?.targetUrl) {
    if(pathName.includes(`${CONSTANTS.URL_PARAMS.BTL_CAMPAIGN_ID}=`)) {
      accessToken = responseQueryParams?.accessToken;
      targetUrl = extractBTLTargetUrl(pathName);
    } else {
      accessToken = responseQueryParams?.accessToken;
      targetUrl = pathName.includes(
        `${CONSTANTS.URL_PARAMS.NEED_VALIDATE_ONE_PASS_USER}=true`
      )
        ? `${responseQueryParams?.targetUrl}=true`
        : responseQueryParams?.targetUrl;
    }
  }

  return { accessToken, targetUrl };
};